import {Helmet} from "react-helmet";
import {RouteHelper, RouteInfo} from "../../route/RouteHelper";
import {
    convertUniversalDateToPersianDate,
    DialogSize,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoCustomSimpleActiveDeActiveChip,
    RaikoDefaultDialogPage,
    RaikoGridOneColumn,
    showErrorMessage,
    RaikoTableTitleContainer, RaikoCustomTable,
    convertCurrencyFormat,
    convertCurrencyFormatPositiveNegative,
    RaikoCustomSimpleChip,
    RaikoChipTypes
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import PointsStatistics from "../../component/statistics/PointsStatistics";
import React, {useEffect, useState} from "react";
import {UnionService} from "../../serverService/unionService/UnionService";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {useNavigate} from "react-router-dom";

export default function Union() {
    const [page, setPage] = useState(0)
    let size = 20;

    useEffect(() => {
        getUnionListFromServer()
        getUnionBalanceFromServer()
    }, []);
    const loading = new LoadingHelper(useLoadingDispatcher())
    const service = new UnionService()
    const [unionData, setUnionData] = useState([])
    const [tableLoading, setTableLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [numberOfItems, setNumberOfItems] = useState(0);
    const [unionBalance, setUnionBalance] = useState(0)


    function tablePreparation(id, rowNumber, fundCash, fundName, cashBalance,
                              totalBalance, countOfGroup, countOfMember, address, status) {
        return {
            id: id,
            number: rowNumber,
            boxCash: fundCash,
            boxName: fundName,
            inventory: cashBalance ? convertCurrencyFormatPositiveNegative(cashBalance) : 0,
            totalBalance: totalBalance ? convertCurrencyFormatPositiveNegative(totalBalance) : 0,
            countOfGroup: countOfGroup && countOfGroup > 0 ? convertCurrencyFormat(countOfGroup) : "صفر",
            countOfMember: countOfMember && countOfMember > 0 ? convertCurrencyFormat(countOfMember) : "صفر",
            address: address,
            status: status ? <RaikoCustomSimpleChip title={"فعال"} type={RaikoChipTypes.success}/>
                : <RaikoCustomSimpleChip title={"غیر فعال"} type={RaikoChipTypes.error}/>,
        }
    }

    function getUnionListFromServer() {
        setTableLoading(true)
        service.getUnionList(page, size).then(
            response => {
                setNumberOfItems(response.numberOfItems)
                setPageCount(response.totalPage)
                setUnionData([])
                response.data.map((item, index) => {
                    setUnionData((prevState => [
                        ...prevState,
                        tablePreparation(
                            item.id,
                            (page * size) + index + 1,
                            item.id,
                            item.name,
                            item.cashBalance,
                            item.totalBalance,
                            item.countOfGroup,
                            item.countOfMember,
                            item.postalAddress,
                            item.enabled
                        )
                    ]))
                })
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoading(false)
        })
    }

    function getUnionBalanceFromServer() {
        loading.show()
        service.getUnionBalance().then(
            response => {
                setUnionBalance(response.balance)
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function handlePaginationChange(newPage) {
        setPage(newPage)
        getUnionListFromServer()
    }

    const navigate = useNavigate()

    function showUnionDetail(unionId) {
        let _fundName = ""
        unionData.map((item) => {
            if (item.id === unionId)
                _fundName = item.boxName
        })
        navigate(RouteHelper.UnionDetail.globalUrl.replace(":id", unionId),
            {state: {title: _fundName}, replace: false}
        )
    }

    return (
        <>
            <Helmet>
                <title>
                    {RouteHelper.Union.name}
                </title>
            </Helmet>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(RouteHelper.Union.name, "")
                        ]}
                    />
                    <PointsStatistics
                        title={"موجودی کل(ریال)"}
                        amount={convertCurrencyFormat(unionBalance)}
                    />
                    <RaikoBaseCardContainer>
                        <RaikoTableTitleContainer
                            title={"اتحادیه"}
                            handleCreateNewItem
                            hasAmount
                            amount={numberOfItems}
                        />
                        <RaikoCustomTable
                            data={unionData}
                            isLoading={tableLoading}
                            header={unionTableHeader}
                            pageCount={pageCount}
                            handlePaginationChange={handlePaginationChange}
                            rowClicked={showUnionDetail}
                        />


                    </RaikoBaseCardContainer>

                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}
const unionTableHeader = [
    {
        id: 'number',
        label: '#',
    },
    {
        id: 'boxCash',
        label: 'کد صندوق',
    },
    {
        id: 'boxName',
        label: 'نام صندوق',
    },
    {
        id: 'inventory',
        label: 'موجودی (ریال)',
    },
    {
        id: 'totalBalance',
        label: 'موجودی نقدی (ریال)',
    },
    {
        id: 'countOfGroup',
        label: 'تعداد گروه ها',
    },
    {
        id: 'countOfMember',
        label: 'تعداد اعضا',
    },
    {
        id: 'address',
        label: 'آدرس',
    },
    {
        id: 'status',
        label: 'وضعیت',
    },
]